import { DesignationState } from 'src/types/redux';
import {
  FETCH_DESIGNATION_FAILURE,
  FETCH_DESIGNATION_REQUEST,
  FETCH_DESIGNATION_SUCCESS,
  DesignationActionType,
} from '../types/designationTypes';

const initialState: DesignationState = {
  error: '',
  loading: false,
  designationData: [],
};

export const designationReducer = (
  state = initialState,
  action: DesignationActionType
): DesignationState => {
  switch (action?.type) {
    case FETCH_DESIGNATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_DESIGNATION_SUCCESS:
      return {
        ...state,
        loading: false,
        designationData: action?.payload,
      };
    case FETCH_DESIGNATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
